import "core-js/modules/es6.array.map.js";
import Application from "../../models/Application";
export var setApplications = function setApplications(state, payload) {
  state.applications = payload.map(function (app) {
    return new Application(app);
  });
};
export var reset = function reset(state) {
  state.applications = null;
};